<template>
  <div class="">
    <div class="">
      <div class="btn-search">
        <div class="simple show-pc" v-show="!drawer">
          <el-input placeholder="可输入 贸易 科技 机械 等" v-model="searchForm.companyName">
            <el-button slot="append" @click="search(1)">查一下</el-button>
          </el-input>
        </div>
        <div class="advanced show-pc" @click="drawer = !drawer">
          <div>{{ drawer ? '普通搜索' : '高级搜索' }}</div>
        </div>
      </div>
      <div class="show-phone">
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item :title="searchForm.countyName ? searchForm.countyName : '区域'" ref="item">
            <van-area
              title="区域选择"
              cancel-button-text="清空"
              :area-list="areaList"
              @confirm="areaConfirm"
              @cancel="areaCancel"
            />
          </van-dropdown-item>
          <van-dropdown-item :title="searchForm.industries[0] ? searchForm.industries.join('、') : '行业'" ref="item2">
            <div style="margin: 3vh 1vw">
              <el-checkbox-group v-model="searchForm.industries" @change="industriesChange">
                <el-checkbox label="生产"></el-checkbox>
                <el-checkbox label="销售"></el-checkbox>
                <el-checkbox label="研发"></el-checkbox>
                <el-checkbox label="服务"></el-checkbox>
              </el-checkbox-group>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <transition name="el-fade-in-linear">
        <div class="search-box " v-show="drawer">
          <el-form
            class="search-form"
            ref="searchForm"
            :model="searchForm"
            label-width="100px"
            @submit.native.prevent="false"
          >
            <el-row>
              <el-col :sm="12">
                <el-form-item label="公司名称" class="name">
                  <el-input
                    size="small"
                    v-model="searchForm.companyName"
                    placeholder="请输入公司名称"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item class="show-pc" label="区域">
                  <el-cascader
                    class="width-100"
                    v-model="searchForm.qy"
                    placeholder="请选择区域"
                    :options="options"
                    :props="{ checkStrictly: true, value: 'label' }"
                    filterable
                    clearable
                    size="small"
                    @change="searchQyChange"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item class="show-phone" label="区域">
                  <el-row>
                    <el-col :span="8"
                      ><div @click="popup1ShowState = true">
                        <el-input v-model="searchForm.province" size="small" :disabled="true"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8"
                      ><div @click="popup2ShowState = true">
                        <el-input v-model="searchForm.city" size="small" :disabled="true"></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div @click="popup3ShowState = true">
                        <el-input v-model="searchForm.county" size="small" :disabled="true"></el-input>
                      </div>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="信息类型">
                  <el-select size="small" v-model="searchForm.infoType" clearable placeholder="请选择">
                    <el-option label="公司转让" value="公司转让"></el-option>
                    <el-option label="资质转让" value="资质转让"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :sm="12">
                <el-form-item label="纳税性质">
                  <el-select size="small" v-model="searchForm.taxNature" clearable placeholder="请选择">
                    <el-option
                      v-for="(item, index) in taxs"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :sm="24">
                <el-form-item label="行业" prop="industries">
                  <el-checkbox-group v-model="searchForm.industries">
                    <el-checkbox label="生产"></el-checkbox>
                    <el-checkbox label="销售"></el-checkbox>
                    <el-checkbox label="研发"></el-checkbox>
                    <el-checkbox label="服务"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :sm="24" class="show-pc">
                <el-form-item label="成立年限">
                  <el-radio-group v-model="searchForm.establishmentTimeSelect">
                    <el-radio size="mini" label="">不限</el-radio>
                    <el-radio size="mini" label="1">1年内</el-radio>
                    <el-radio size="mini" label="2">1-3年</el-radio>
                    <el-radio size="mini" label="3">3-5年</el-radio>
                    <el-radio size="mini" label="4">5-10年</el-radio>
                    <el-radio size="mini" label="5">10年以上</el-radio>
                    <el-radio size="mini" label="6"
                      ><el-popover placement="bottom" width="auto" trigger="click" v-model="visible">
                        <div class="picker-show">
                          <el-input size="mini" type="text" :value="searchForm.establishmentTimeShowA2" />
                          <el-input size="mini" type="text" :value="searchForm.establishmentTimeShowB2" />
                          <el-button type="primary" plain size="mini" @click="visible = false">取消</el-button>
                          <el-button type="primary" size="mini" @click="dateConfirm">确定</el-button>
                        </div>
                        <div class="picker-pannel">
                          <div class="date-pannel">
                            <DatePanel
                              v-model="searchForm.establishmentTimeA2"
                              @change="dateChange"
                              :show-time="false"
                              :disabled-date="disabledDate"
                            />
                          </div>
                          <div>
                            <DatePanel
                              v-model="searchForm.establishmentTimeB2"
                              @change="dateChange2"
                              :show-time="false"
                              :disabled-date="disabledDate2"
                            />
                          </div>
                        </div>
                        <el-button
                          :type="searchForm.establishmentTimeSelect === '6' ? 'primary' : ''"
                          @click="searchForm.establishmentTimeSelect = '6'"
                          size="mini"
                          slot="reference"
                          >{{ time ? time : '自定义' }}</el-button
                        >
                      </el-popover></el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :sm="16">
                <el-form-item label="经营范围" prop="natureBusiness">
                  <el-input size="small" type="textarea" v-model="searchForm.natureBusiness"></el-input>
                </el-form-item>
              </el-col>
              <el-col :sm="8">
                <el-form-item class="btn text-center">
                  <el-button plain size="small" class="search" @click="reset">重置 </el-button>
                  <el-button icon="el-icon-search" type="primary" size="small" class="search" @click="search(1)"
                    >查询
                  </el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </transition>
    </div>
    <van-popup v-model="popup1ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-area title="标题" :area-list="areaList" />
    </van-popup>
    <van-popup v-model="popup2ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="省"
        :columns="options1"
        @confirm="pickerConfirm1"
        @cancel="pickerCancel1"
      />
    </van-popup>
    <van-popup v-model="popup2ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="市"
        :columns="options2"
        @confirm="pickerConfirm2"
        @cancel="pickerCancel2"
      />
    </van-popup>
    <van-popup v-model="popup3ShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="pickerQy"
        show-toolbar
        title="县/区"
        :columns="options3"
        @confirm="pickerConfirm3"
        @cancel="pickerCancel3"
      />
    </van-popup>
  </div>
</template>

<script>
import cityData from '../../../utils/Data'
import DatePanel from '../../../components/DatePicker.vue'
export default {
  name: 'SearchForm',
  components: {
    DatePanel: DatePanel
  },
  props: {
    searchForm: {
      type: Object,
      required: () => {
        return {}
      }
    }
  },
  data() {
    return {
      taxs: [
        { code: '小规模', name: '小规模' },
        { code: '一般纳税人', name: '一般纳税人' }
      ],
      persons: [],
      cycle2: [
        { code: 0, name: '到期' },
        { code: '30', name: '30天' },
        { code: '60', name: '60天' },
        { code: '90', name: '90天' },
        { code: '120', name: '120天' },
        { code: '180', name: '180天' }
      ],
      cycle: [
        { roleId: '月付', roleName: '月付' },
        { roleId: '季付', roleName: '季付' },
        { roleId: '半年付', roleName: '半年付' },
        { roleId: '年付', roleName: '年付' }
      ],
      jobs: [
        { text: '所有行业', value: '' },
        { text: '生产', value: '生产' },
        { text: '销售', value: '销售' },
        { text: '研发', value: '研发' },
        { text: '服务', value: '服务' }
      ],
      options: cityData,
      options1: [],
      options2: [],
      options3: [],
      areaList: {},
      popup1ShowState: false,
      popup2ShowState: false,
      popup3ShowState: false,
      drawer: false,
      visible: false
    }
  },
  computed: {
    time: function() {
      if (this.searchForm.establishmentTimeA && this.searchForm.establishmentTimeB) {
        return [this.searchForm.establishmentTimeA, this.searchForm.establishmentTimeB].join('至')
      } else {
        return ''
      }
    }
  },
  methods: {
    timeFormat(date, format) {
      if (!date) {
        return ''
      }
      // 日期解析
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return format
    },
    dateChange(date) {
      this.searchForm.establishmentTimeShowA2 = this.timeFormat(date, 'yyyy-MM-dd')
    },
    dateChange2(date) {
      this.searchForm.establishmentTimeShowB2 = this.timeFormat(date, 'yyyy-MM-dd')
    },
    disabledDate(time) {
      const endDateVal = this.searchForm.establishmentTimeShowB2
        ? new Date(this.searchForm.establishmentTimeShowB2)
        : ''
      if (endDateVal) {
        return time.getTime() >= endDateVal.setDate(endDateVal.getDate())
      }
    },
    disabledDate2(time) {
      const beginDateVal = this.searchForm.establishmentTimeShowA2
        ? new Date(this.searchForm.establishmentTimeShowA2)
        : ''
      if (beginDateVal) {
        return time.getTime() <= beginDateVal.setDate(beginDateVal.getDate() - 1)
      }
    },
    dateConfirm() {
      console.log(this.searchForm)
      if (
        (this.searchForm.establishmentTimeShowA2 && !this.searchForm.establishmentTimeShowB2) ||
        (!this.searchForm.establishmentTimeShowA2 && this.searchForm.establishmentTimeShowB2)
      ) {
        return console.log('日期选择不全！')
      } else if (this.searchForm.establishmentTimeShowA2 && this.searchForm.establishmentTimeShowB2) {
        this.searchForm.establishmentTimeA = this.searchForm.establishmentTimeShowA2
        this.searchForm.establishmentTimeB = this.searchForm.establishmentTimeShowB2
      } else {
        this.searchForm.establishmentTimeA = ''
        this.searchForm.establishmentTimeB = ''
      }
      this.visible = false
    },
    handleClose() {
      this.drawer = false
    },
    establishmentTimeChange(val) {
      if (val) {
        this.searchForm.establishmentTimeA = val[0]
        this.searchForm.establishmentTimeB = val[1]
      } else {
        this.searchForm.establishmentTimeA = ''
        this.searchForm.establishmentTimeB = ''
      }
    },
    establishmentTimeAchange(val) {
      if (this.searchForm.establishmentTimeB && val > this.searchForm.establishmentTimeB) {
        this.searchForm.establishmentTimeA = ''
        return this.$root.$children[0].vueAlert({ message: '开始时间不能大于结束时间！', type: 'error' })
      }
    },
    establishmentTimeBchange(val) {
      if (this.searchForm.establishmentTimeA && val < this.searchForm.establishmentTimeA) {
        this.searchForm.establishmentTimeB = ''
        return this.$root.$children[0].vueAlert({ message: '结束时间不能小于开始时间！', type: 'error' })
      }
    },
    reset() {
      this.$emit('reset')
    },
    // 行业 popup 选择变化
    industriesChange(val) {
      console.log(val)
      console.log(this.searchForm.industries)
      this.$refs.item2.toggle()
      this.search(1)
    },
    // 区域选择确认
    areaConfirm(vals) {
      this.searchForm.province = vals[0].name
      this.searchForm.city = vals[1].name
      this.searchForm.county = vals[2].name
      this.searchForm.provinceName = vals[0].name
      this.searchForm.cityName = vals[1].name
      this.searchForm.countyName = vals[2].name
      this.$refs.item.toggle()
      this.search(1)
    },
    // 区域选择取消
    areaCancel() {
      this.searchForm.province = ''
      this.searchForm.city = ''
      this.searchForm.county = ''
      this.searchForm.provinceName = ''
      this.searchForm.cityName = ''
      this.searchForm.countyName = ''
      this.$refs.item.toggle()
      this.search(1)
    },
    // 区域省确认
    pickerConfirm1(value, index) {
      if (value.value !== this.searchForm.province) {
        this.searchForm.city = ''
        this.searchForm.county = ''
      }
      this.searchForm.province = value.value
      this.popup1ShowState = false
      const city = this.options[index].children
      this.options2 = []
      for (let i = 0; i < city.length; i++) {
        this.options2.push({
          label: city[i].label,
          text: city[i].label,
          value: city[i].label,
          city: city[i].children
        })
      }
    },
    // 区域省取消
    pickerCancel1() {
      this.searchForm.qy = []
      this.searchForm.province = ''
      this.popup1ShowState = false
    },
    // 区域市确认
    pickerConfirm2(value, index) {
      console.log(value)
      if (value.value !== this.searchForm.city) {
        this.searchForm.county = ''
      }
      this.searchForm.city = value.value
      const city = value.city
      this.options3 = []
      for (let i = 0; i < city.length; i++) {
        this.options3.push({
          label: city[i].label,
          text: city[i].label,
          value: city[i].label
        })
      }
      this.popup2ShowState = false
    },
    // 区域市取消
    pickerCancel2() {
      this.searchForm.qy = []
      this.searchForm.city = ''
      this.popup2ShowState = false
    },
    // 区域县确认
    pickerConfirm3(value, index) {
      console.log(value)
      this.searchForm.county = value.value
      this.searchForm.qy = [this.searchForm.county, this.searchForm.city, this.searchForm.county]
      this.popup3ShowState = false
    },
    // 区域县取消
    pickerCancel3() {
      this.searchForm.qy = []
      this.searchForm.county = ''
      this.popup3ShowState = false
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询
    search(page) {
      this.$emit('search', page)
    },
    // 查询 ： 区域更改
    searchQyChange(val) {
      console.log(val)
      if (val) {
        this.searchForm.province = val[0]
        this.searchForm.city = val[1]
        this.searchForm.county = val[2]
      }
    }
  },
  mounted() {
    for (let i = 0; i < this.options.length; i++) {
      this.options1.push({
        label: this.options[i].label,
        text: this.options[i].label,
        value: this.options[i].label
      })
    }
    if (this.searchForm.county) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].text === this.searchForm.county) {
          const index = i
          const vals = this.options[i]
          vals.city = vals.children
          this.pickerConfirm1(vals, index)
          if (this.searchForm.city) {
            for (let j = 0; j < vals.children.length; j++) {
              if (vals.children[j].text === this.searchForm.city) {
                const index2 = j
                const vals2 = vals.children[j]
                vals2.city = vals2.children
                this.pickerConfirm2(vals2, index2)
                if (this.searchForm.county) {
                  for (let k = 0; k < vals2.children.length; k++) {
                    if (vals2.children[k].text === this.searchForm.county) {
                      const index3 = k
                      const vals3 = vals2.children[k]
                      this.pickerConfirm3(vals3, index3)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped>
.el-radio-group {
  /deep/.el-radio {
    margin-right: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-radio__label {
      padding-left: 0;
    }
    .el-radio__input {
      display: none;
    }
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}

.show-phone {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
    .el-input__prefix {
      height: 34px;
    }
  }
}
.el-autocomplete-suggestion.el-popper {
  width: 300px !important;
}
.import-btn {
  position: relative;
  .import-excel {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    left: 0;
    top: 0;
  }
}
.picker-show {
  display: flex;
}
.picker-pannel {
  display: flex;
  .date-pannel {
    margin-right: 10px;
  }
}
.search-box {
  background: #fff;
  padding: 10px 20px 10px 0;
  margin-bottom: 12px;
  /deep/.el-input__inner,
  .el-textarea__inner {
    border-radius: 0;
  }
  /deep/.el-checkbox__inner {
    display: none;
  }
}
.btn-search {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  .simple {
    width: 550px;
    margin-bottom: 20px;
  }
  .advanced {
    cursor: pointer;
    width: 100px;
    margin-left: 10px;
    color: black;
    text-decoration: underline;
    font-size: 14px;
    // line-height: 50px;
  }
  /deep/.el-input-group__append,
  /deep/.el-input-group__prepend {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
  .el-button {
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
  }
}
.advanced {
  cursor: pointer;
  width: 100px;
  margin-left: 10px;
  color: black;
  text-decoration: underline;
  font-size: 14px;
  margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  .title {
    font-weight: 700;
    font-size: 1.4rem !important;
    line-height: 2 !important;
    margin-bottom: 0;
    height: auto !important;
  }
  .flow {
    padding: 0 0 20px;
  }
  .search-box {
    background: #fff;
    padding: 10px 0;
  }
  .btn-search {
    padding-top: 0;
  }
}
</style>
